import React, { Component } from 'react';
import { connect } from 'react-redux';
import { mergeDeepLeft, path, clone } from 'ramda';
import loadImage from 'blueimp-load-image';

import DragAndDrop from '../../common/DragAndDrop';
import {
  getAttachmentsById,
  deleteAttachmentById,
  uploadAttachmentData,
} from '../../api/attachments';
import './style.css'
import config from '../../config';
import { addNotification as notify } from 'reapop';

export class Attachments extends Component {

  constructor(props) {
    super(props);
    this.state = {
      fileToUpload: []
    }
    this.renderAttachments = this.renderAttachments.bind(this);
    this.removeAttachment = this.removeAttachment.bind(this);
    this.handleAttachmentUpload = this.handleAttachmentUpload.bind(this);
    this.removeAttachmentFromLocalState = this.removeAttachmentFromLocalState.bind(this);
    this.uploadAttachment = this.uploadAttachment.bind(this);
  }

  componentWillMount() {
    this.props.loadAttachments(this.props.id, this.props.attachmentType);
  }

  removeAttachment(attachmentId) {
    this.props.removeAttachment(attachmentId, this.props.id, this.props.attachmentType);
  }

  renderAttachments() {
    const attachments = path(['attachments', 'currentAttachments'], this.props);
    const id = this.props.id;
    const attachmentUrl = this.props.attachmentType ? `${this.props.attachmentType}/` : '';
    const attachmentsList = [];
    if (attachments && attachments.length > 0) {
      for (let i = 0; i < attachments.length; i++) {
        attachmentsList.push(
          <div className="card rounded" style={{ padding: '10px', marginBottom: '6px' }} key={i}>
            {attachments[i].type ? <span style={{ color: 'green' }}>QC</span> : null}
            <span className="pull-left">
              <div id={attachments[i].attachment}
                className="card-block-wrap-inside card-block-file card-block-wrap-image-from-server">
                <img className="card-block-files-for-upload pull-left"
                  src={`${config.apiEndpoint}/uploads/attachments/${attachmentUrl}${id}/${attachments[i].attachment}`}
                  onError={() => {
                    document.getElementById(attachments[i].attachment).innerHTML = '<i class="fa fa-file-o fa-4x card-block-thumb-mini"></i>';
                  }}
                />
              </div>
              <div style={{
                display: 'inline-grid'
              }}><b
                style={{
                  position: 'relative',
                }}
              >
                  {attachments[i].name}
                </b>
                <span style={{
                  marginTop: '7px'
                }}>
                  <a target="_blank" download={attachments[i].name}
                    className='btn btn-rounded btn-icon ui-btn card-block-button-a'
                    href={`${config.apiEndpoint}/uploads/attachments/${attachmentUrl}${id}/${attachments[i].attachment}`}>
                    <i className="material-icons">expand_more</i><span>Download</span>
                  </a>
                  <a target="_blank" className='btn btn-rounded btn-icon ui-btn card-block-button-a'
                    href={`${config.apiEndpoint}/uploads/attachments/${attachmentUrl}${id}/${attachments[i].attachment}`}>
                    <i className="material-icons">fullscreen</i><span>View</span>
                  </a>
                  <button
                    type="button"
                    className="btn btn-rounded btn-icon ui-btn card-block-button-a"
                    onClick={() => { this.removeAttachment(attachments[i].id); }}
                  >
                    <i className="material-icons">remove_circle_outline</i>
                    <span className="color-default">Remove</span>
                  </button>
                </span>
              </div>
            </span>
          </div>
        );
      }
    }

    return attachmentsList;
  }

  renderLocalAttachments(fileToUpload) {
    return fileToUpload.map((name, index) => {
      return <div className="card-block-wrap">
        <div className="card-block-close-wrap">
          <i className="material-icons card-block-cancel"
            onClick={() => this.removeAttachmentFromLocalState(index)}>cancel</i>
        </div>
        <div className="card-block-wrap-inside card-block-file">
          {(fileToUpload[index].imageSrc ?
            <img src={fileToUpload[index].imageSrc}
              className={'card-block-files-for-upload' + (fileToUpload[index].loaded && ' loaded')} />
            :
            <i className="fa fa-file-o fa-4x card-block-thumb"></i>
          )}
        </div>
        <div className="card-block-wrap-inside">
          <span>{fileToUpload[index].name}</span>
          <span> - {fileToUpload[index].size}</span>
        </div>
      </div>
    })
  }

  removeAttachmentFromLocalState(idOfFileInState) {
    const filesObjectToMerge = clone(this.state);
    delete filesObjectToMerge.fileToUpload[idOfFileInState];
    this.setState(mergeDeepLeft(filesObjectToMerge, this.state));
  }

  // Component method
  async handleAttachmentUpload(e) {
    const files = [...e.target.files];
    const pattern = /image-*/;

    const filesObjectToMerge = clone(this.state);
    for (let file of files) {
      const reader = new FileReader();
      const positionForNewFile = filesObjectToMerge.fileToUpload.length;
      const fileSize = ('' + (file.size / 1048576)).slice(0, 4);
      if (fileSize > 500) {
        this.props.addErrorNotification(file.name + " is bigger than 500Mb.");
        continue;
      }
      filesObjectToMerge.fileToUpload[positionForNewFile] = {
        name: file.name,
        size: fileSize + 'Mb',
        fileObject: file,
      };
      if (file.type.match(pattern)) {
        const result = await loadImage(file, { orientation: true, meta: true, canvas: true });
        filesObjectToMerge.fileToUpload[positionForNewFile].imageSrc = result.image.toDataURL();
        filesObjectToMerge.fileToUpload[positionForNewFile].loaded = true;
        this.setState(mergeDeepLeft(filesObjectToMerge, this.state));
      }
      this.setState(mergeDeepLeft(filesObjectToMerge, this.state));
    }
  }

  uploadAttachment(qc) {
    for (let key in this.state.fileToUpload) {
      const formData = new FormData();
      const file = this.state.fileToUpload[key].fileObject;
      formData.append('file', file);
      this.props.uploadAttachment(this.props.id, this.props.attachmentType, formData, qc);
    }

    this.setState(mergeDeepLeft({ fileToUpload: [] }, this.state));
  }

  handleDrop = (files) => {
    const e = { target: { files: Array.from(files) } };
    this.handleAttachmentUpload(e);
  }

  render() {
    const fileToUpload = this.state.fileToUpload;
    const enableUpploadAsQC = this.props.enableUpploadAsQC;

    return (
      <DragAndDrop handleDrop={this.handleDrop}>
        <div>
          <div className="card rounded mb-3">
            <div className="card-header rounded-top">
              Attachment(s)
            </div>
            <div className="card-block">
              {this.renderAttachments()}
            </div>
          </div>
          <div className="card rounded mb-3">
            <div className="card-header rounded-top">
              Upload File
            </div>
            <div className="card-block">
              <div className="card-block-buttons">
                <label
                  ref="uploadBtn"
                  className="btn btn-rounded btn-icon ui-btn pull-right"
                  onClick={() => { this.uploadAttachment(true); }}
                  style={{
                    position: 'relative',
                    display: (enableUpploadAsQC ? '' : 'none')
                  }}
                >
                  <i className="material-icons">send</i>
                  <span className="color-default">Upload as QC</span>
                </label>
                <label
                  ref="uploadBtn"
                  className="btn btn-rounded btn-icon ui-btn pull-right"
                  onClick={() => { this.uploadAttachment(); }}
                  style={{
                    position: 'relative',
                    marginRight: (enableUpploadAsQC ? '10px' : '0'),
                  }}
                >
                  <i className="material-icons">send</i>
                  <span className="color-default">Upload</span>
                </label>
                <label
                  className="btn btn-rounded btn-icon ui-btn pull-right"
                  style={{
                    position: 'relative',
                    marginRight: '10px',
                  }}>
                  <i className="material-icons">attachment</i>
                  <span className="color-default">Browse</span>
                  <input ref="input" type="file" onChange={this.handleAttachmentUpload}
                    className="d-none"
                    multiple="true" />
                </label>
              </div>
            </div>
            <div className="card-block-container-of-files">{this.renderLocalAttachments(fileToUpload)}</div>
          </div>
        </div>
      </DragAndDrop>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadAttachments: (id, type) => {
      getAttachmentsById(id, type)(dispatch);
    },
    removeAttachment: (id, type) => {
      deleteAttachmentById(id, type)(dispatch);
    },
    uploadAttachment: (id, type, formData, qc) => {
      uploadAttachmentData(id, type, formData, qc)(dispatch);
    },
    addErrorNotification: (message) => {
      dispatch(notify({
        title: 'Upload attachment',
        message: message,
        status: 'error',
        position: 'tr',
        dismissible: true,
        dismissAfter: 3000,
      }));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Attachments);



// WEBPACK FOOTER //
// ./src/containers/Attachments/index.js